export const EMBEDDED_SOURCE_PRODUCTS = {
	'Google Drive': 'Google Drive',
	Loom: 'Loom',
	Google: 'Google',
	GoogleDrive: 'GoogleDrive',
} as const;
